import { render, staticRenderFns } from "./DsdAssets.vue?vue&type=template&id=4bfa296b"
import script from "./DsdAssets.vue?vue&type=script&lang=js"
export * from "./DsdAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports